module.exports = {
    rollUp: {
        transitionAppearTimeout: 800,
        transitionEnterTimeout: 800,
        transitionLeaveTimeout: 800
    },
    slideLeft: {
        transitionAppearTimeout: 500,
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 500
    },
    slideRight: {
        transitionAppearTimeout: 500,
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 500
    }
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/transition/transitions-style.js
 **/